import React, { useState, useEffect, useRef } from "react";
import Sidebar from "react-sidebar";
import { connect } from "react-redux";

import { closeSidebarAction, showMarkAction } from "../../redux/actions/marks";
import send from "../../static/icons/send.svg";
import {
  addCommentAction,
  deleteErrorsAction,
  writeCommentAction,
  getCommentsAction,
  addLikeDislikeAction
} from "../../redux/actions/likeAndComments";
import SidebarData from "./SidebarData";

const UserSidebar = props => {
  const [handleOpen, setHandleOpen] = useState({ open: false });
  const [photos, setPhotos] = useState([]);
  const [videoArray, setVideo] = useState([]);
  const commentsRef = useRef();
  const scrollingDiv = useRef();
  const sidebarStyles = {
    sidebar: {
      zIndex: 12,
      position: "absolute",
      height: "100%",
      top: 0,
      bottom: 0,
      transition: "transform .3s ease-out",
      WebkitTransition: "-webkit-transform .3s ease-out",
      willChange: "transform",
      overflowY: "auto",
      maxWidth: "100vw",
      width: "400px",
      padding: "20px",
      borderBottomRightRadius: "10px",
      borderTopRightRadius: "10px",
      background: "#fff",
      boxSizing: "border-box"
    },
    root: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: "hidden"
    },
    content: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflowY: "auto",
      WebkitOverflowScrolling: "touch",
      transition: "left .3s ease-out, right .3s ease-out"
    },
    overlay: {
      zIndex: 1,
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0,
      visibility: "hidden",
      transition: "opacity .3s ease-out, visibility .3s ease-out",
      backgroundColor: "#fff",
      maxWidth: "300px",
      width: "260px",
      borderBottomRightRadius: "10px",
      borderTopRightRadius: "10px"
    },
    dragHandle: {
      zIndex: 1,
      position: "absolute",
      top: 0,
      bottom: 0
    }
  };

  useEffect(() => {
    if (props.mark && props.mark.media) {
      const photoArray = props.mark.media.filter(item => item.path_url);
      setPhotos(photoArray);
      const videoArray = props.mark.media.filter(item => item.url);
      setVideo(videoArray);
    }
  }, [props.mark]);

  const likeHandler = (value, type, item) => {
    const data = {
      id: item.id,
      value,
      type
    };
    if (type === "MarkComment") {
      props.addLikeDislikeAction(data, refreshCommentsHandler);
    }

    if (type === "MarkItem") {
      props.addLikeDislikeAction(data, refreshMarkItemHandler);
    }
  };

  const refreshCommentsHandler = page => {
    props.getCommentsAction(props.commentsId, page);
  };

  const refreshMarkItemHandler = () => {
    props.showMarkAction(props.mark.id);
  };

  const handleClick = () => {
    setHandleOpen({ open: true });
  };

  const handleClose = () => {
    props.closeSidebarAction();
  };

  const commentsHandler = e => {
    if (Object.keys(props.errors).length > 0) {
      props.deleteErrorsAction();
    }
    props.writeCommentAction(e.target.value);
  };

  const sendComment = mark => {
    const data = {
      mark_id: mark.id,
      value: props.comment
    };
    props.addCommentAction(data, refreshCommentsHandler);
  };

  const handlePageChange = page => {
    props.getCommentsAction(props.commentsId, page);
  };

  const handleScrollTop = () => {
    commentsRef.current.scrollIntoView();
  };

  return (
    <Sidebar
      ref={scrollingDiv}
      sidebar={
        <SidebarData
          handleClose={handleClose}
          handleClick={handleClick}
          photos={photos}
          handleOpen={handleOpen}
          setHandleOpen={setHandleOpen}
          videoArray={videoArray}
          commentsRef={commentsRef}
          commentsHandler={commentsHandler}
          send={send}
          sendComment={sendComment}
          handlePageChange={handlePageChange}
          handleScrollTop={handleScrollTop}
          likeHandler={likeHandler}
          loading={props.loading}
          refreshMarkItemHandler={refreshMarkItemHandler}
        />
      }
      open={props.open}
      styles={sidebarStyles}
    >
      {""}
    </Sidebar>
  );
};

const mapStateToProps = state => {
  return {
    mark: state.marks.mark,
    open: state.marks.isOpenSidebar,
    loading: state.marks.loading,
    errors: state.likes.errors,
    me: state.auth.me,
    comment: state.likes.comment,
    comments: state.likes.comments,
    map: state,
    commentsId: state.likes.commentsId
  };
};

const mapDispatchToProps = {
  closeSidebarAction,
  addCommentAction,
  deleteErrorsAction,
  writeCommentAction,
  getCommentsAction,
  addLikeDislikeAction,
  showMarkAction
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSidebar);
